import type {
  CreatePropertyProfessionalInsightsParams,
  CreatePropertyProfessionalInsightsResponse,
} from './interfaces';

const llmUrl = '/ms/insight/propertyProfessionalInsights';

export const createPropertyProfessionalInsights = async (
  token: string,
  params: CreatePropertyProfessionalInsightsParams,
  signal?: AbortSignal
): Promise<CreatePropertyProfessionalInsightsResponse> => {
  const response = await fetch(llmUrl, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    credentials: 'include',
    body: JSON.stringify(params),
    signal: signal ?? AbortSignal.timeout(60_000),
  });

  if (!response.ok) {
    const error = new Error(
      `HTTP error! status: ${response.status}`
    ) as Error & {
      response: { status: number };
    };
    error.response = { status: response.status };
    throw error;
  }

  return (await response.json()) as CreatePropertyProfessionalInsightsResponse;
};
